"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpisPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var framer_motion_1 = require("framer-motion");
var client_utils_1 = require("../../utils/client-utils");
var PageHeaderPortal_1 = __importDefault(require("./PageHeaderPortal"));
var brand_hooks_1 = require("../../hooks/brand-hooks");
var variants = {
    closed: {
        //clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
        opacity: 0,
    },
    open: {
        //clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
        opacity: 1,
    },
    exit: {
        // Animating to same as open apparently doesn't work
        //clipPath: "polygon(0 1%, 100% 1%, 100% 1%, 0 1%)",
        opacity: 0,
    },
};
var IpisPage = function (props) {
    var spanFull = !props.headerProps && !props.tabProps;
    var span2 = !spanFull && (!props.headerProps || !props.tabProps);
    var span1 = !spanFull && !span2;
    (0, brand_hooks_1.useExternalBrandTheme)({ externalBrandTheme: props.externalBrandTheme });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PageHeaderPortal_1.default, __assign({}, props.headerProps)), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.main, { className: (0, client_utils_1.classNames)(
                //"border-4 border-red-400",
                !props.noLayoutStyling && "flex h-full w-full flex-col", "col-start-1", spanFull && "row-span-3 row-start-1", span2 && "row-span-2 row-start-2", span1 && "row-start-2 lg:row-start-3", props.className), variants: variants, initial: "closed", animate: "open", exit: "exit", transition: { duration: 0.3 }, children: props.children })] }));
};
exports.IpisPage = IpisPage;
